import { createAction, handleActions } from "redux-actions";
import {
  _getPetsList,
  _getAllPetsList,
  _getPetInfoById,
  _getPetListByCustomer,
  _getCustomerList,
  _createNewPet,
  _getCustomerPetList,
  _editCustomerPet,
  _getCustomerDetails,
  _deletePet,
} from "~shared/httpService/apis";
import ActionTypes from "~shared/constants/actionTypes";

import customers from "~shared/stubs/customer.json";
import { _getAttendantByVenue } from "../../../shared/httpService/apis";

const initialState = {
  attendant_list:{loading: false, response: [], hasError: false, error: {}},
  pet_list: { loading: false, response: [], hasError: false, error: {} },
  all_pets_list: { loading: false, response: [], hasError: false, error: {} },
  pet_info_by_id: { loading: false, response: [], hasError: false, error: {} },
  customer_pet_list: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  customer_list: { loading: false, response: [], hasError: false, error: {} },
  add_new_pet: { loading: false, response: [], hasError: false, error: {} },
  pet_list_customer: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  edit_customer_pet: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  customer_details: {
    loading: false,
    response: [],
    hasError: false,
    error: {},
  },
  delete_pet: { loading: false, response: [], hasError: false, error: {} },
};

export const getPetsListStart = createAction(ActionTypes.GET_PETS_LIST);
export const getPetsListSuccess = createAction(
  ActionTypes.GET_PETS_LIST_SUCCESS,
  (response) => response
);
export const getPetsListError = createAction(
  ActionTypes.GET_PETS_LIST_ERROR,
  (error) => error
);

// export const getPetsList =
//   (page = "", pageSize, searchQuery, customerId) =>
//   (dispatch) => {
//     dispatch(getPetsListStart());
//     return _getPetsList(page, pageSize, searchQuery, customerId)
//       .then((response) => {
//         dispatch(getPetsListSuccess(response));
//       })
//       .catch((error) => {
//         dispatch(getPetsListError(error));
//       });
//   };

//for loading attendant by venue for dropdown 


export const getPetsList =
  (page = "", pageSize, searchQuery, customerId,serviceId) =>
  (dispatch) => {
    dispatch(getPetsListStart());
    return _getPetsList(page, pageSize, searchQuery, customerId, serviceId)
      .then((response) => {
        dispatch(getPetsListSuccess(response));
      })
      .catch((error) => {
        dispatch(getPetsListError(error));
      });
  };



export const getAttendantByVenueStart = createAction(ActionTypes.GET_ATTENDANT_BY_VENUE);
export const getAttendantByVenueSuccess = createAction(
  ActionTypes.GET_ATTENDANT_BY_VENUE_SUCCESS,
  (response) => response
);
export const getAttendantByVenueError = createAction(
  ActionTypes.GET_ATTENDANT_BY_VENUE_ERROR,
  (error) => error
);


  export const getAttendantByVenue = (value,serviceId)=>(dispatch)=>{
    dispatch(getAttendantByVenueStart());
    return _getAttendantByVenue(value, serviceId).
    then((response)=>{
      dispatch(getAttendantByVenueSuccess(response));

    }).catch((error)=>{
      dispatch(getAttendantByVenueError(error));
    })
  }

export const getAllPetsListStart = createAction(ActionTypes.GET_ALL_PETS_LIST);
export const getAllPetsListSuccess = createAction(
  ActionTypes.GET_ALL_PETS_LIST_SUCCESS,
  (response) => response
);
export const getAllPetsListError = createAction(
  ActionTypes.GET_ALL_PETS_LIST_ERROR,
  (error) => error
);

export const getAllPetsList = () => (dispatch) => {
  dispatch(getAllPetsListStart());
  return _getAllPetsList()
    .then((response) => {
      dispatch(getAllPetsListSuccess(response));
    })
    .catch((error) => {
      dispatch(getAllPetsListError(error));
    });
};

export const getPetInfoByIdStart = createAction(ActionTypes.GET_PET_INFO_BY_ID);
export const getPetInfoByIdSuccess = createAction(
  ActionTypes.GET_PET_INFO_BY_ID_SUCCESS,
  (response) => response
);
export const getPetInfoByIdError = createAction(
  ActionTypes.GET_PET_INFO_BY_ID_ERROR,
  (error) => error
);

export const getPetInfoById = (id) => (dispatch) => {
  dispatch(getPetInfoByIdStart());
  return _getPetInfoById(id)
    .then((response) => {
      dispatch(getPetInfoByIdSuccess(response));
    })
    .catch((error) => {
      dispatch(getPetInfoByIdError(error));
    });
};

export const getPetListByCustomerStart = createAction(
  ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID
);
export const getPetListByCustomerSuccess = createAction(
  ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID_SUCCESS,
  (response) => response
);
export const getPetListByCustomerError = createAction(
  ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID_ERROR,
  (error) => error
);

export const getPetListByCustomer = (customerId) => (dispatch) => {
  dispatch(getPetListByCustomerStart());
  return _getPetListByCustomer(customerId)
    .then((response) => {
    dispatch(getPetListByCustomerSuccess(response));
    })
    .catch((error) => {
      dispatch(getPetListByCustomerError(error));
    });
};

export const getCustomerListStart = createAction(ActionTypes.GET_CUSTOMER_LIST);
export const getCustomerListSuccess = createAction(
  ActionTypes.GET_CUSTOMER_LIST_SUCCESS,
  (response) => response
);
export const getCustomerListError = createAction(
  ActionTypes.GET_CUSTOMER_LIST_ERROR,
  (error) => error
);

export const getCustomerList = (schema, customerName) => (dispatch) => {
  dispatch(getCustomerListStart());
  return _getCustomerList(schema, customerName)
    .then((response) => {
      dispatch(getCustomerListSuccess(response));
    })
    .catch(() => {
      //to be changed error
      // dispatch(getCustomerListError(customers));
      dispatch(getCustomerListSuccess(customers));
    });
};

export const addNewPetStart = createAction(ActionTypes.ADD_NEW_PET);
export const addNewPetSuccess = createAction(
  ActionTypes.ADD_NEW_PET_SUCCESS,
  (response) => response
);
export const addNewPetError = createAction(
  ActionTypes.ADD_NEW_PET_ERROR,
  (error) => error
);

export const createNewPet = (data) => (dispatch) => {
  dispatch(addNewPetStart());
  return _createNewPet(data)
    .then((response) => {
      dispatch(addNewPetSuccess(response));
    })
    .catch((error) => {
      dispatch(addNewPetError(error));
    });
};

export const getPetListCustomerStart = createAction(
  ActionTypes.GET_CUSTOMER_PET_LIST
);
export const getPetListCustomerSuccess = createAction(
  ActionTypes.GET_CUSTOMER_PET_LIST_SUCCESS,
  (response) => response
);
export const getPetListCustomerError = createAction(
  ActionTypes.GET_CUSTOMER_PET_LIST_ERROR,
  (error) => error
);

export const getCustometPets = (id) => (dispatch) => {
  dispatch(getPetListCustomerStart());
  return _getCustomerPetList(id)
    .then((response) => {
      dispatch(getPetListCustomerSuccess(response));
    })
    .catch((error) => {
      dispatch(getPetListCustomerError(error));
    });
};

export const editPetStart = createAction(ActionTypes.CUSTOMER_PET_EDIT);
export const editPetSuccess = createAction(
  ActionTypes.CUSTOMER_PET_EDIT_SUCCESS,
  (response) => response
);
export const editPetError = createAction(
  ActionTypes.CUSTOMER_PET_EDIT_ERROR,
  (error) => error
);

export const customerPetEdit = (id, data) => (dispatch) => {
  dispatch(editPetStart());
  return _editCustomerPet(id, data)
    .then((response) => {
      dispatch(editPetSuccess(response));
    })
    .catch((error) => {
      dispatch(editPetError(error));
    });
};

export const getCustomerDetailsStart = createAction(
  ActionTypes.GET_CUSTOMER_DETAILS
);
export const getCustomerDetailsSuccess = createAction(
  ActionTypes.GET_CUSTOMER_DETAILS_SUCCESS,
  (response) => response
);
export const getCustomerDetailsError = createAction(
  ActionTypes.GET_CUSTOMER_DETAILS_ERROR,
  (error) => error
);

export const getCustomerDetails = (schema, id) => (dispatch) => {
  dispatch(getCustomerDetailsStart());
  return _getCustomerDetails(schema, id)
    .then((response) => {
      dispatch(getCustomerDetailsSuccess(response));
    })
    .catch((error) => {
      dispatch(getCustomerDetailsError(error));
    });
};

export const deletePetStart = createAction(ActionTypes.DELETE_PET);
export const deletePetSuccess = createAction(
  ActionTypes.DELETE_PET_SUCCESS,
  (response) => response
);
export const deletePetError = createAction(
  ActionTypes.DELETE_PET_ERROR,
  (error) => error
);

export const deletePet = (id) => (dispatch) => {
  dispatch(deletePetStart());
  return _deletePet(id)
    .then((response) => {
      dispatch(deletePetSuccess(response));
    })
    .catch((error) => {
      dispatch(deletePetError(error));
    });
};

const reducer = handleActions(
  {

    //GET ATTENDANT BY VENUE 
    [ActionTypes.GET_ATTENDANT_BY_VENUE]: (state) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ATTENDANT_BY_VENUE_SUCCESS]: (state, action) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ATTENDANT_BY_VENUE_ERROR]: (state, action) => ({
      ...state,
      attendant_list: {
        ...state.attendant_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
 
   //PETS_LIST
    [ActionTypes.GET_PETS_LIST]: (state) => ({
      ...state,
      pet_list: {
        ...state.pet_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PETS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      pet_list: {
        ...state.pet_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PETS_LIST_ERROR]: (state, action) => ({
      ...state,
      pet_list: {
        ...state.pet_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //ALL_PETS_LIST
    [ActionTypes.GET_ALL_PETS_LIST]: (state) => ({
      ...state,
      all_pets_list: {
        ...state.all_pets_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_ALL_PETS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      all_pets_list: {
        ...state.all_pets_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_vPETS_LIST_ERROR]: (state, action) => ({
      ...state,
      all_pets_list: {
        ...state.all_pets_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //PET_INFO_BY_ID
    [ActionTypes.GET_PET_INFO_BY_ID]: (state) => ({
      ...state,
      pet_info_by_id: {
        ...state.pet_info_by_id,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_INFO_BY_ID_SUCCESS]: (state, action) => ({
      ...state,
      pet_info_by_id: {
        ...state.pet_info_by_id,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_INFO_BY_ID_ERROR]: (state, action) => ({
      ...state,
      pet_info_by_id: {
        ...state.pet_info_by_id,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //CUSTOMER_PET_LIST
    [ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID]: (state) => ({
      ...state,
      customer_pet_list: {
        ...state.customer_pet_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID_SUCCESS]: (state, action) => ({
      ...state,
      customer_pet_list: {
        ...state.customer_pet_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_PET_LIST_BY_CUSTOMER_ID_ERROR]: (state, action) => ({
      ...state,
      customer_pet_list: {
        ...state.customer_pet_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //CUSTOMER_LIST
    [ActionTypes.GET_CUSTOMER_LIST]: (state) => ({
      ...state,
      customer_list: {
        ...state.customer_list,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_LIST_SUCCESS]: (state, action) => ({
      ...state,
      customer_list: {
        ...state.customer_list,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_LIST_ERROR]: (state, action) => ({
      ...state,
      customer_list: {
        ...state.customer_list,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //ADD_NET_PET
    [ActionTypes.ADD_NEW_PET]: (state) => ({
      ...state,
      add_new_pet: {
        ...state.add_new_pet,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.ADD_NEW_PET_SUCCESS]: (state, action) => ({
      ...state,
      add_new_pet: {
        ...state.add_new_pet,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.ADD_NEW_PET_ERROR]: (state, action) => ({
      ...state,
      add_new_pet: {
        ...state.add_new_pet,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),

    //CUSTOMER_PETS_LIST
    [ActionTypes.GET_CUSTOMER_PET_LIST]: (state) => ({
      ...state,
      pet_list_customer: {
        ...state.pet_list_customer,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_PET_LIST_SUCCESS]: (state, action) => ({
      ...state,
      pet_list_customer: {
        ...state.pet_list_customer,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_PET_LIST_ERROR]: (state, action) => ({
      ...state,
      pet_list_customer: {
        ...state.pet_list_customer,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //EDIT_PET
    [ActionTypes.CUSTOMER_PET_EDIT]: (state) => ({
      ...state,
      edit_customer_pet: {
        ...state.edit_customer_pet,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.CUSTOMER_PET_EDIT_SUCCESS]: (state, action) => ({
      ...state,
      edit_customer_pet: {
        ...state.edit_customer_pet,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.CUSTOMER_PET_EDIT_ERROR]: (state, action) => ({
      ...state,
      edit_customer_pet: {
        ...state.edit_customer_pet,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //GET_CUSTOMER_DETAILS
    [ActionTypes.GET_CUSTOMER_DETAILS]: (state) => ({
      ...state,
      customer_details: {
        ...state.customer_details,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      customer_details: {
        ...state.customer_details,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.GET_CUSTOMER_DETAILS_ERROR]: (state, action) => ({
      ...state,
      customer_details: {
        ...state.customer_details,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
    //DELETE_PET
    [ActionTypes.DELETE_PET]: (state) => ({
      ...state,
      delete_pet: {
        ...state.delete_pet,
        loading: true,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.DELETE_PET_SUCCESS]: (state, action) => ({
      ...state,
      delete_pet: {
        ...state.delete_pet,
        response: action.payload,
        loading: false,
        hasError: false,
        error: {},
      },
    }),
    [ActionTypes.DELETE_PET_ERROR]: (state, action) => ({
      ...state,
      delete_pet: {
        ...state.delete_pet,
        error: action.payload,
        loading: false,
        hasError: true,
        response: {},
      },
    }),
  },
  initialState
);

export default reducer;